import React from 'react'
import { LearnHero } from './LearnHero'
import { TopicsSection } from '../topics/TopicsSection'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { Topic, VisibleTopics } from 'services/ContentfulService/models/topics'
import { Product } from 'services/ContentfulService/models/product'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { FaqSection } from '../common/FaqSection/FaqSection'
import { FAQ } from 'services/ContentfulService/models/fact'
import { LearnContainer } from '../common'
import { ApplySection } from '../common/applySection'
import { PrioritizedContent } from 'experiences/shared/ContentfulImage/PriorityContext'
import { ArticleSection } from 'experiences/shared/ArticleSection'

interface Props {
	featuredArticles: ArticleSummary[]
	latestArticles: ArticleSummary[]
	featuredTopics: Topic[]
	partners: Partner[]
	products: Product[]
	faqs: FAQ[]
}

export const LearnHomePage = ({
	featuredArticles,
	latestArticles,
	featuredTopics,
	products,
	faqs
}: Props): JSX.Element => {
	return (
		<div>
			<LearnHero products={products} />
			<LearnContainer>
				<PrioritizedContent>
					<ArticleSection title="Featured Articles" articles={featuredArticles} linkTo="/learn/articles" />
				</PrioritizedContent>
				<TopicsSection topics={VisibleTopics(featuredTopics)} title="Featured Topics" linkTo="/learn/topics" />
				<FaqSection faqs={faqs} />
				<ArticleSection
					title="Latest Articles"
					articles={latestArticles.slice(0, 8)}
					linkTo="/learn/articles"
					isSmallCard
				/>
			</LearnContainer>
			<ApplySection />
		</div>
	)
}
